module.exports = __webpack_public_path__ + "img/vertical_4_5_7005.ae05d783.png";